
import GoToStores from './go-to-stores';

export default GoToStores;
